import { Center, type CenterProps, Spinner } from '@/ui';

export const AppLoader = (props: CenterProps) => (
  <Center flex="1" {...props}>
    <Spinner />
  </Center>
);
